import { api } from 'services/api'

export async function updateClientParams(payload) {
  const { data } = await api.put('/clients/params', payload)
  return data
}
